import { TFunction } from '@lyearn/i18n';
import { Radio, VideoOutline } from '@lyearn/icons';
import { EventSubTypeEnum } from '@/types/schema';

export const getTypeItems = ({ t }: { t: TFunction }) => {
  return [
    {
      id: EventSubTypeEnum.GroupSession,
      title: t('Events:Editor.GroupSession'),
      description: t('Events:Editor.GroupSessionDescription'),
      Icon: VideoOutline,
    },
    {
      id: EventSubTypeEnum.Webinar,
      title: t('Events:Webinar'),
      description: t('Events:Editor.WebinarDescription'),
      Icon: Radio,
    },
  ];
};
